/*
 * @Author: zhechuan.Wang
 * @Date: 2023-12-05 16:28:45
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2024-10-17 09:45:57
 * @Description: file content
 * @FilePath: \gfmis-card-ppt\src\store\modules\subsidizeProject.js
 */
const state = {
  subsidizeProject: {
    mofDivCode: '', // 当前树节点编码
    mofDivName: '', // 当前树节点名称
    spName: '', // 项目名称
    fiscalYear: '', // 年度
  },
  titleTvArray: [],
  viewCount: '', // 访问次数统计
};
const mutations = {
  setCurrentNode(state, current) {
    state.subsidizeProject = {
      ...state.subsidizeProject,
      ...current,
    }
    window.sessionStorage.setItem('subsidizeProject', JSON.stringify(state.subsidizeProject));
  },
  setSpName(state, spName) {
    state.subsidizeProject = {
      ...state.subsidizeProject,
      spName,
    }
    window.sessionStorage.setItem('subsidizeProject', JSON.stringify(state.subsidizeProject));
  },
  setFiscalYear(state, fiscalYear) {
    state.subsidizeProject = {
      ...state.subsidizeProject,
      fiscalYear
    }
    window.sessionStorage.setItem('subsidizeProject', JSON.stringify(state.subsidizeProject));
  },
  // 缓存访问量
  setViewCount(state, viewCount) {
    state.viewCount = viewCount;
  },
};

const getters = {
  getSubsidizeProject() {
    const subProject = JSON.parse(window.sessionStorage.getItem('subsidizeProject'))
    return subProject || {}
  },
  // 获取当前树节点label
  getCurrentNode() {
    const subProject = JSON.parse(window.sessionStorage.getItem('subsidizeProject'))
    return subProject?.mofDivName
  },
  // 获取表头导航标题
  getTitleTvArray() {
    const subProject = JSON.parse(window.sessionStorage.getItem('subsidizeProject'))
    const { mofDivName, spName } = subProject || {}
    return [mofDivName, spName];
  },
  // 获取访问量
  getViewCount(state) {
    return state.viewCount;
  },
};
export default {
  state,
  mutations,
  getters,
};